
    import __i18nConfig from '@next-translate-root/i18n'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import ProfileMenuItem from "components/Profile/ProfileMenuItem";
import useTranslation from "next-translate/useTranslation";
import { useRouter } from "next/router";
import { FaCalculator } from "react-icons/fa";
import { resetCheckoutStore, useCheckoutStore, } from "../../components/ReuseableCompos/SharedDonatePages/DonateModal/CheckoutState";
import ZakatInputStep from "../../components/ReuseableCompos/SharedDonatePages/DonateModal/Steps/ZakatInput/ZakatInputStep";
import ZakatLayout from "../../layout/ZakatLayout";
const Zakat = () => {
    const { push } = useRouter();
    const { t } = useTranslation("common");
    const [setModalVisible, addStepToHistory] = useCheckoutStore((state) => [
        state.setModalVisible,
        state.addStepToHistory,
    ]);
    const handleShowCalculateModal = () => {
        resetCheckoutStore();
        addStepToHistory(ZakatInputStep.name);
        setModalVisible(true);
    };
    const items = [
        {
            title: "zakat_calculator",
            description: "zakat_description",
            icon: FaCalculator,
            customIcon: true,
            href: "/zakat/calculator"
        },
        {
            title: "zakat_pay_now",
            description: "zakat_pay_now",
            icon: "fe-credit-card",
            onClick: () => {
                handleShowCalculateModal();
            }
        },
    ];
    return (
    // SEO in Layout
    <div className="list-group list-group-flush fw-medium fs-lg">
      {items?.map((item, i) => (<ProfileMenuItem key={i} title={t(item.title)} customIcon={item.customIcon} icon={item.icon} desc={t(item.description)} href={item.href ? item.href : null} onClick={item.onClick ? item.onClick : null}/>))}
    </div>);
};
export default Zakat;
Zakat.Layout = ZakatLayout;

    async function __Next_Translate__getStaticProps__1a13f66beb3__(ctx) {
      
      return {
        
        
        props: {
          
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/zakat/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || (() => Promise.resolve({})),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a13f66beb3__ as getStaticProps }
  